import React from 'react';

const localStyle = {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
};

export default (props) => <div {...props} style={{ ...props.style, ...localStyle }} />;
